import { IOrderItem } from "../../../types/IOrderItem"

export const getTotalPrice = (orderItems:IOrderItem[]) => {
  let totalPrice = 0
  orderItems.forEach((i) => {
    totalPrice = (totalPrice + i.price * i.quantity) as number
  })
  return totalPrice
}
